import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import LNBView from "./view";

export interface LNBProps {
    currentSection: number;
    totalSections: number;
}

function LNB({ currentSection, totalSections }: LNBProps) {
    const dotRefs = useRef<(HTMLDivElement | null)[]>([]);

    useEffect(() => {
        dotRefs.current.forEach((dot, index) => {
            if (dot) {
                gsap.to(dot, {
                    backgroundColor: index === currentSection ? '#C99FF3' : 'var(--black-6)',
                    duration: 0.3
                });
            }
        });
    }, [currentSection]);

    useEffect(() => {
        dotRefs.current = new Array(totalSections).fill(null);
    }, [totalSections]);

    const viewProps = {
        dotRefs,
        totalSections
    };

    return <LNBView {...viewProps} />;
}

export default LNB;
